export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ACTIVE_DIRECTORY_CLIENT_ID, //reale - bb7851ee-1862-47f9-8155-aa5e33434abb
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ACTIVE_DIRECTORY_TENANT_ID}`, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: process.env.REACT_APP_REDIRECT_URL, //reale tenant id- 75584e34-72c0-4772-b459-a9fe78fec27c
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
